import type { Size } from '../types';

/**
 * Legacy mapping: component size → hardcoded gap values (CSS strings).
 *
 * Interim solution until the Eclipse Design System is finalized.
 * Values are hardcoded for now to avoid over-engineering a mapping that may soon be obsolete.
 */
export const legacyFormGapSizeMap = {
  extraSmall: '6px',
  small: '8px',
  medium: '10px',
  large: '12px',
  extraLarge: '14px',
} as const satisfies Record<Size, string>;

/**
 * Legacy mapping: component size → hardcoded font-size values (CSS strings).
 *
 * Interim solution until the Eclipse Design System is finalized.
 * Values are hardcoded for now to avoid over-engineering a mapping that may soon be obsolete.
 */
export const legacyFontSizeBySizeMap = {
  extraSmall: '0.766rem',
  small: '0.8125rem',
  medium: '0.875rem',
  large: '1rem',
  extraLarge: '1.1rem',
} as const satisfies Record<Size, string>;
